import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';

const Text = ({ children, options }: Props) => React.createElement(TextBox, { children, options });

export default Text;